import React from 'react';

import {
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown,
} from 'reactstrap';

import {gt} from 'app/utils/i18n';

interface Props {
  itemIndex: number;
  numItems: number;
  onReorder: (from: number, to: number) => void;
  canRemove?: boolean;
  onRemove: () => unknown;
  small?: boolean;
}

// this component is used for to reorder/delete the field and it's choices
export function ReorderOrDeleteButton({
  itemIndex,
  numItems,
  onRemove,
  canRemove = true,
  onReorder,
  small,
}: Props) {
  return (
    <UncontrolledDropdown className="input-group-append bg-white">
      <DropdownToggle
        color="outline-secondary dropdown-toggle border-left-0"
        caret={false}
        style={{borderColor: '#ced4da'}}
      >
        <i className="fa fa-ellipsis-v px-1" />
      </DropdownToggle>
      <DropdownMenu right>
        {itemIndex > 0 ? (
          <DropdownItem
            onClick={() => onReorder(itemIndex, itemIndex - 1)}
            className={small ? 'btn-sm' : undefined}
          >
            <i className="fa fa-fw fa-arrow-up" /> {gt('Move up')}
          </DropdownItem>
        ) : null}
        {itemIndex < numItems - 1 ? (
          <DropdownItem
            onClick={() => onReorder(itemIndex, itemIndex + 1)}
            className={small ? 'btn-sm' : undefined}
          >
            <i className="fa fa-fw fa-arrow-down" /> {gt('Move down')}
          </DropdownItem>
        ) : null}
        <DropdownItem
          onClick={() => onRemove()}
          disabled={!canRemove}
          className={small ? 'btn-sm' : undefined}
        >
          <i className="fa fa-fw fa-times" /> {gt('Remove')}
        </DropdownItem>
      </DropdownMenu>
    </UncontrolledDropdown>
  );
}
